/* Mood & Life · comportamiento de las fichas de producto y de la guía de ingredientes.
   Todo es mejora progresiva: sin este archivo la página se lee y se navega igual.
   - "Ver secciones" de la barra de producto en móvil
   - "Lo que hay que saber": botón con "i" que abre una ventana
   - desplegables de la ficha: un enlace a un ancla que está dentro de un desplegable cerrado lo abre
   - selector caliente / frío: marca el texto que corresponde
   - índice de la guía: marca el ingrediente que se está leyendo y, en móvil, es un desplegable fijo */
(() => {
  const d = document; d.documentElement.classList.add('js');

  // barra de producto en móvil
  const pbar = d.querySelector('.pbar'), mas = pbar && pbar.querySelector('.mas');
  if (mas) {
    const pon = v => { pbar.classList.toggle('abierta', v); mas.setAttribute('aria-expanded', v); };
    mas.addEventListener('click', () => pon(!pbar.classList.contains('abierta')));
    pbar.querySelectorAll('ul a').forEach(a => a.addEventListener('click', () => pon(false)));
    d.addEventListener('keydown', e => e.key === 'Escape' && pon(false));
  }

  // "Lo que hay que saber": el botón con la "i" abre una ventana con el contenido que ya está en la página (se mueve, no se carga).
  // Sin este script es un <details> normal. Escape y el botón cierran; al cerrar, el foco vuelve a quien la abrió. Los enlaces a #saber la abren.
  const sd = d.querySelector('details.saber-d');
  if (sd && window.HTMLDialogElement) {
    const sum = sd.querySelector('summary'), cont = sd.querySelector('.saber-c');
    const dlg = d.createElement('dialog'); dlg.className = 'dlg-saber'; dlg.setAttribute('aria-labelledby', 'saber-t');
    const x = d.createElement('button'); x.type = 'button'; x.className = 'cerrar'; x.setAttribute('aria-label', 'Cerrar'); x.textContent = '×';
    cont.querySelectorAll('[data-iman]').forEach(el => el.removeAttribute('data-iman'));
    dlg.append(x, cont); d.body.append(dlg);
    sd.classList.add('ventana'); sum.setAttribute('role', 'button'); sum.setAttribute('aria-haspopup', 'dialog');
    let origen = null;
    const abreSaber = o => { origen = o || sum; if (!dlg.open) dlg.showModal(); };
    sum.addEventListener('click', e => { e.preventDefault(); abreSaber(sum); });
    dlg.addEventListener('click', e => { if (e.target === dlg || e.target === x) dlg.close(); });
    dlg.addEventListener('close', () => { origen && origen.focus(); });
    d.addEventListener('click', e => { const a = e.target.closest && e.target.closest('a[href$="#saber"]'); if (a && a.pathname === location.pathname) { e.preventDefault(); abreSaber(a); } });
    if (/^#saber\b/.test(location.hash)) abreSaber(sum);
  }

  // anclas dentro de desplegables: "Información nutricional" de la barra abre su bloque
  const abre = () => { const id = decodeURIComponent(location.hash.slice(1)); if (!id || /[=&]/.test(id)) return;
    const t = d.getElementById(id), det = t && !t.closest('.ventana') && (t.matches('details') ? t : t.closest('details'));
    if (det && !det.open) { det.open = true; t.scrollIntoView(); } };
  addEventListener('hashchange', abre); abre();
  if (location.hash.includes('abre')) d.querySelectorAll('details.desp,details.fte').forEach(x => x.open = true);   // gancho de captura

  // caliente / frío: resalta el texto del modo elegido (los dos textos están siempre en la página)
  d.querySelectorAll('[data-conm]').forEach(g => {
    const marca = m => d.querySelectorAll(`[data-modo-txt]`).forEach(x => x.classList.toggle('on', x.dataset.modoTxt === m));
    g.querySelectorAll('button').forEach(b => b.addEventListener('click', () => marca(b.dataset.modo)));
    const act = g.querySelector('[aria-pressed="true"]'); act && marca(act.dataset.modo);
  });

  // índice de la guía de ingredientes
  const indice = d.querySelector('.indice'), enl = [...d.querySelectorAll('.indice a[href^="#"]')];
  if (indice && enl.length) {
    const boton = indice.querySelector('.mas'), actual = indice.querySelector('[data-actual]');
    const pon = v => { indice.classList.toggle('abierta', v); boton && boton.setAttribute('aria-expanded', v); };
    if (boton) {
      boton.addEventListener('click', () => pon(!indice.classList.contains('abierta')));
      enl.forEach(a => a.addEventListener('click', () => pon(false)));
      d.addEventListener('keydown', e => e.key === 'Escape' && pon(false));
      if (location.hash.includes('indice')) pon(true);   // gancho de captura
    }
    if ('IntersectionObserver' in window) {
      const porId = Object.fromEntries(enl.map(a => [a.hash.slice(1), a]));
      const io = new IntersectionObserver(es => es.forEach(e => {
        if (!e.isIntersecting) return;
        enl.forEach(a => a.removeAttribute('aria-current'));
        const a = porId[e.target.id]; if (!a) return;
        a.setAttribute('aria-current', 'true'); if (actual) actual.textContent = a.textContent;
      }), { rootMargin: '-20% 0px -70% 0px' });
      Object.keys(porId).forEach(id => { const s = d.getElementById(id); s && io.observe(s); });
    }
  }
})();
